import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [
      'en', // English
      'es', // Spanish
      'fr', // French
      'de', // German
      'it', // Italian
      'pt', // Portuguese
      'ru', // Russian
      'zh', // Chinese
      'ja', // Japanese
      'ko', // Korean
      'ar', // Arabic
      'hi', // Hindi
      'bn', // Bengali
      'ur', // Urdu
      'tr', // Turkish
      'vi', // Vietnamese
      'th', // Thai
      'nl', // Dutch
      'pl', // Polish
      'uk', // Ukrainian
      'ro', // Romanian
      'fa', // Persian
      'id', // Indonesian
      'ms', // Malay
      'sw', // Swahili
      'zu', // Zulu
      'yo', // Yoruba
      'ha', // Hausa
      'am', // Amharic
      'he', // Hebrew
      'el'  // Greek
    ],
    
    // Performance optimizations
    load: 'languageOnly',
    
    // Updated backend configuration with more reliable settings
    backend: {
      loadPath: './locales/{{lng}}/{{ns}}.json',
      addPath: './locales/{{lng}}/{{ns}}.missing.json',
      allowMultiLoading: false,
      crossDomain: true,
      withCredentials: false,
      requestOptions: {
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'default',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      reloadInterval: false
    },
    
    // Detection optimizations
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode']
    },

    // Resource handling
    ns: ['common', 'translation'],
    defaultNS: 'translation',
    fallbackNS: 'common',

    interpolation: {
      escapeValue: false
    },

    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
      skipTranslationOnMissing: false
    }
  });

export default i18n;